module.exports = __webpack_public_path__ + "static/img/g-save-icon.05351151.png";